import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonModule } from 'primeng/button';
import { ButtonMenuComponent } from './components/button-menu/button-menu.component';
import { FloatButtonComponent } from './components/float-button/float-button.component';
import { OrderButtonComponent } from './components/order-button/order-button.component';



@NgModule({
  declarations: [ButtonMenuComponent, FloatButtonComponent,OrderButtonComponent],
  imports: [
    CommonModule,
    ButtonModule,
    OverlayModule,
    MatMenuModule
  ],
  exports: [ButtonMenuComponent, FloatButtonComponent,OrderButtonComponent]
})
export class ADButtonModule { }
